import {Container, Grid, Typography} from "@mui/material";

export const BlueBanner = () => {
    const barContainerStyle = {
        backgroundColor: '#009ADE',
        textAlign: 'center',
    }

    return <Grid item sx={barContainerStyle}>
        <Container maxWidth={"xl"}>
            <Grid container sx={{padding: "20px 0", position: "relative" }}>
                <Grid item lg={12}>
                    <Grid container sx={{position: "relative", padding:"0", justifyContent: "center" }}>
                        <Typography variant={"h3"} sx={{color: "#FFF", fontWeight:"bold", margin: "0", textAlign: "center", fontSize: "20px", maxWidth: "1200px"}}>
                            Did you know the LSP features video telling stories? Head to the <a href="/video-telling" style={{color: "#FFF", textDecoration: "underline"}}>Video Telling</a> page and listen to authors bring their implementation stories to life. You'll also find recordings of our past webinars in this&nbsp;section.

                           {/* On the virtual sidelines of the 80th UN General Assembly, we invite you to engage in a discussion on sustainable financing for sexual and reproductive health and rights (SRHR) on 23 September at 8 AM EDT/14:00 CEST.<br/> 
                           <span style={{marginTop: "10px", display: "inline-block"}}>Please register for the event&nbsp;<a href="http://bit.ly/SecuringTheFutureSRHR" style={{color: "#FFF", textDecoration: "underline"}}>here</a>.</span> */}
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
        </Container>
    </Grid>
};